var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 10.5003C18.3334 15.1027 14.6024 18.8337 10 18.8337C5.39765 18.8337 1.66669 15.1027 1.66669 10.5003C1.66669 5.89795 5.39765 2.16699 10 2.16699C14.6024 2.16699 18.3334 5.89795 18.3334 10.5003ZM9.16669 7.16699C9.16669 6.70676 9.53978 6.33366 10 6.33366C10.4603 6.33366 10.8334 6.70676 10.8334 7.16699C10.8334 7.62723 10.4603 8.00033 10 8.00033C9.53978 8.00033 9.16669 7.62723 9.16669 7.16699ZM9.16669 9.66699C9.16669 9.20676 9.53978 8.83366 10 8.83366C10.4603 8.83366 10.8334 9.20675 10.8334 9.66699V13.8337C10.8334 14.2939 10.4603 14.667 10 14.667C9.53978 14.667 9.16669 14.2939 9.16669 13.8337V9.66699Z",
    fill: "#33FF9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a4baf1e443e41cabd819a1ebe3daf4d1.svg";
export { ForwardRef as ReactComponent };